import { Flex, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import DownloadButtons from '@/travo/components/ui/buttons/DownloadButtons';
import { useCopy } from '@/travo/i18n';
import { LanguageMenu } from './LanguageMenu';
import { useNavItems } from './useNavItems';

export const DesktopNav = () => {
  const copy = useCopy();
  const { links } = useNavItems();

  return (
    <Flex
      as="nav"
      aria-label={copy.nav.primary}
      // Tighter at tablet width so CJK labels and the language select fit on one line
      gap={{ base: '16px', lg: '28px' }}
      whiteSpace="nowrap"
      align="center"
      display={{ base: 'none', md: 'flex' }}
    >
      {links.map((link) => (
        <Link
          key={link.to}
          asChild
          color="ink"
          fontWeight="500"
          py="10px"
          textDecoration="none"
          _hover={{ color: 'stampDeep', textDecoration: 'underline', textUnderlineOffset: '6px' }}
        >
          <RouterLink to={link.to}>{link.label}</RouterLink>
        </Link>
      ))}
      <LanguageMenu />
      <DownloadButtons variant="nav-menu" />
    </Flex>
  );
};
